<template>
<div class="container">
    <div v-if="address.length > 0">
        <ul class="address-list">
            <li class="address-item" @click="currentRadio = index" v-for="(item, index) of address" :key="index">
                <!-- <div class="address-radio">
                    <div class="radio-hook" :class="{ 'radio-hook-selected ': index == currentRadio }">
                        <img src="../../../assets/icon/icon_hook.png" />
                    </div>
                </div> -->
                <div class="address-content" @click="choseRadio(index, item.id)">
                    <span class="address-name">{{ item.receiver_name }} {{ item.receiver_mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') }}</span>
                    <div class="address-address">
                        <span>{{ item.address.province }}-{{ item.address.city }}-{{
                  item.address.district
                }}-{{ item.address.line1 }}</span>
                    </div>
                </div>
                <div class="address-edit">
                    <span class="address-defult" v-if="item.is_default == 1">默认</span>
                    <div class="set-default" v-if="item.is_default != 1" @click="openshow(item)">
                        设为默认
                    </div>
                    <div style="color: #d80c18" @click="goEditAddress(item)">编辑</div>
                </div>
            </li>
        </ul>
        <van-dialog v-model="show" @confirm="setdefault(tempItem)" show-cancel-button>
            <div class="tui-receiving">确认设为默认吗？</div>
        </van-dialog>
        <div class="fixed padding-bottom">
            <van-button round block color="var(--theme-color-main)" type="primary" @click="submit" class="b-button" style="margin-top: 15px">添加地址</van-button>
        </div>
    </div>
    <div v-else>
        <notData :back="back" title="无收货地址" content="抱歉，您还未添加收货地址" :img="nodeImg" button="去添加" @click="submit"></notData>
    </div>
</div>
</template>

<script>
import wx from "weixin-js-sdk";
import {
    searchUserAddrList,
    updateUserAddr
} from "../../../api/api";
import notData from "@/components/notData.vue";
export default {
    components: {
        notData,
    },
    data() {
        return {
            show: false,
            back: false,
            currentRadio: 0,
            addressList: [],
            addressId: String(this.$route.query.address) == "undefined" ? '' : this.$route.query.address,
            nodeImg: require("../../../../static/images/order/noAddress.png"),
            address: [],
        };
    },
    methods: {
        openshow(item) {
            this.show = true;
            this.tempItem = item;
        },
        //设为默认地址
        async setdefault(tempItem) {
            // console.log(tempItem)
            let obj = {
                receiver_name: tempItem.receiver_name, //用户名
                receiver_mobile: tempItem.receiver_mobile, //手机号
                address: {
                    province_id: tempItem.address.province_id,
                    province: tempItem.address.province,
                    city_id: tempItem.address.city_id,
                    city: tempItem.address.city,
                    district_id: tempItem.address.district_id,
                    district: tempItem.address.district,
                    postcode: tempItem.address.postcode,
                    line1: tempItem.address.line1,
                },
                is_default: 1,
                is_service: 0,
            };

            let params = {
                token: "a756dd83d7fb496f84398003ad031361",
                param: JSON.stringify(obj),
                id: tempItem.id,
            };

            let res = await updateUserAddr(params);
            if (res.code == "0000") {
                this.getUserAddress();
                this.$toast("设为默认成功");
            }
        },
        choseRadio(index, id) {
            // if(window.location.href == "http://localhost:8080/m/#/orders/shippingAddress") {
            //     return false
            // } else {
            this.currentRadio = index;
            if (this.addressId != '' || (this.$route.query.status != null && this.$route.query.status == "submitOrder")) {
                // this.$router.go(-1); //返回上一层
              if(this.$route.query.sourceCenter==='article'){
                const json = {
                  giftPackageId: this.$route.query.giftPackageId,
                  activityNo: this.$route.query.activityNo,
                  access_token: this.$route.query.access_token,
                  userInterestsId: this.$route.query.userInterestsId,
                  productId: this.$route.query.productId,
                  userId: this.$route.query.userId,
                  shareList: this.$route.query.shareList,
                  sourceCenter: this.$route.query.sourceCenter,
                };
                this.$router.push({
                  path: "/submitOrder",
                  query: json
                });
              }else{
                this.$router.push({
                  path: "/submitOrder",
                  query: {
                    productList: this.$route.query.productList,
                    sources:this.$route.query.sources,
                    orderType:this.$route.query.orderType
                  },

                });
              }
                this.$store.state.address = index;
            }

            // }
        },
        goEditAddress(item) {
            //获取到已选中的城市，用于修改地址页面展示
            const province = item.address.province;
            const province_id = item.address.province_id;
            const citys = item.address.city;
            const city_id = item.address.city_id;
            const district = item.address.district;
            const district_id = item.address.district_id;
            const newAddress = province + "-" + citys + "-" + district;
            //获取详细地址
            const address = item.address.line1;
            //获取城市id----vant需要
            const region = [];
            const sheng = {
                code: province_id,
                name: province
            };
            const shi = {
                code: city_id,
                name: citys
            };
            const qu = {
                code: district_id,
                name: district
            };
            region[0] = sheng;
            region[1] = shi;
            region[2] = qu;

            this.id = item.id;
            this.type = 2;
            this.$router.push({
                path: "/orders/editAddress",
                query: {
                    type: 2,
                    id: item.id,
                    goodsId: this.goodsId,
                    goodsNum: this.goodsNum,
                    couponId: this.couponId,
                    //将内容传递到编辑地址页面
                    name: item.receiver_name, //获取收货人姓名
                    phone: item.receiver_mobile, //获取收货人手机号
                    city: newAddress, //用于显示的省市区
                    address: address, //用于显示的详细地址
                    region: region,
                    status: this.$route.query.status == null ? '' : this.$route.query.status,
                    productList: encodeURIComponent( JSON.stringify(  this.$route.query.productList)),
                },
            });
        },
        submit() {
            this.type = 1;
            this.$router.push({
                path: "/orders/editAddress",
                query: {
                    type: 1,
                    goodsId: this.goodsId,
                    goodsNum: this.goodsNum,
                    //将内容传递到编辑地址页面
                    name: "",
                    phone: "",
                    city: "",
                    region: [],
                    status: this.$route.query.status == null ? '' : this.$route.query.status,
                    productList: encodeURIComponent( JSON.stringify(  this.$route.query.productList)),
                },
            });
        },
        async getUserAddress() {
            const res = await searchUserAddrList({
                // token: "a756dd83d7fb496f84398003ad031361",
            }); 
            if (res.data[0] == null) {
                this.address = [];
            } else {
                this.address = res.data.sort((a, b) => b.is_default - a.is_default);
                if (this.addressId == '') return false;
                for (var i = 0; i < this.address.length; i++) {
                    if (this.address[i].id == this.addressId.id) {
                        this.currentRadio = i;
                        return false;

                    }
                }
            }
        },
    },
    mounted: function (options) {
        this.productList = this.$route.query.productList; //获取路由参数
        this.getUserAddress();
    },
};
</script>

<style lang="scss">
.tui-receiving {
    text-align: center;
    padding: 100px;
}

.address-list {
    height: auto;
    background-color: #fff;

    .address-item {
        // padding: 6px 0;
        margin: 0 34px;
        padding-top: 20px;
        padding-bottom: 13px;
        border-top: 1px solid rgba($color: #e8e8e8, $alpha: 0.5);
        display: flex;
        flex-direction: row;
        // height: 145px;
        align-items: center;

        .address-radio {
            width: 50px;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;

            .radio-hook {
                height: 26px;
                width: 26px;
                border: 2px solid #d5d5d5;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;

                img {
                    height: 18px;
                    width: 18px;
                }
            }

            .radio-hook-selected {
                border: 2px solid $theme-color-main;
                background-color: $theme-color-main;
            }
        }

        .address-content {
            flex: 1;
            height: 100%;
            display: flex;
            flex-direction: column;
            padding-right: 38px;

            .address-address {
                flex: 2;
                display: flex;
                align-items: center;
                font-size: 28px;
                color: #666666;
                line-height: 42px;
                font-weight: 400;
            }

            .address-name {
                font-size: 28px;
                display: flex;
                flex: 1;
                align-items: center;
                margin-bottom: 8px;
            }
        }

        .address-edit {
            width: 150px;
            height: 102px;
            border-left: 1px solid rgba($color: #858585, $alpha: 0.5);
            // color: $theme-color-main;
            font-size: 26px;
            text-align: right;
            line-height: 52px;
        }
    }
}

.address-defult {
    display: inline-block;
    width: 62px;
    height: 33px;
    line-height: 33px;
    border: 1px solid $theme-color-main;
    text-align: center;
    color: $theme-color-main;
    font-size: 24px;
    margin-right: 6px;
    vertical-align: top;
}
</style>
